import type { Provider } from '@angular/core';
import { InjectionToken } from '@angular/core';

/**
 * Multi-provider registry of inlined SVG markup keyed by fl-icons.ts export
 * name (e.g. `flTrophy`). Consumed by `<fl-icon [useNgIcon]="true">` to render
 * without an HTTP fetch. Register entries with `provideFlIcons({...})`.
 */
export const FL_ICON_REGISTRY = new InjectionToken<
  readonly Record<string, string>[]
>('FL_ICON_REGISTRY', {
  providedIn: 'root',
  factory: () => [],
});

/**
 * Registers a collection of inlined SVG markup with `FL_ICON_REGISTRY` so
 * descendant `<fl-icon [useNgIcon]="true">` instances can resolve them.
 *
 * @example
 *   providers: [provideFlIcons({ flTrophy, flAccount })]
 */
export function provideFlIcons(icons: Record<string, string>): Provider {
  return { provide: FL_ICON_REGISTRY, multi: true, useValue: icons };
}
